import styled from '@emotion/styled'

export const Label = styled.div`
  color: #818080;
  font-size: 0.875rem;
`
